import { GroupDto } from "@coaching-culture/types";
import {
  Box,
  Button,
  Flex,
  IconButton,
  SortableTable,
  SortableTableColumn,
  Text,
} from "@coaching-culture/ui";
import { useCallback, useMemo, useState } from "react";
import { FaTimes, FaUsers } from "react-icons/fa";
import { GroupSelectModal } from "./GroupSelectModal";

export type GroupSelectionTableProps = {
  value: GroupDto[];
  onChange: (val: GroupDto[]) => void;
};

export function GroupSelectionTable({
  value,
  onChange,
}: GroupSelectionTableProps) {
  const [modal, setModal] = useState(false);

  const remove = useCallback(
    (u: GroupDto) => {
      onChange(value.filter((x) => x.id !== u.id));
    },
    [value, onChange],
  );

  const cols = useMemo(
    (): SortableTableColumn<GroupDto>[] => [
      {
        name: "name",
        label: "Name",
      },
      {
        name: "userCounts",
        label: "User Count",
        format: (x) => x.members.filter((x) => x.membershipLevel > 0).length,
      },
      {
        name: "controls",
        label: "",
        props: {
          style: {
            textAlign: "right",
            width: "1px",
          },
        },
        format: (x) => (
          <IconButton color="danger" icon={FaTimes} onClick={() => remove(x)} />
        ),
      },
    ],
    [remove],
  );

  const add = (groups: GroupDto[]) => {
    onChange(groups);
    setModal(false);
  };

  return (
    <>
      {modal && <GroupSelectModal onSelect={add as any} />}
      <Flex mb={2} justifyContent="space-between" alignItems="flex-end">
        <Text>
          <strong>Groups:</strong> {value.length}
        </Text>
        <Flex>
          <Button
            icon={FaUsers}
            mr={1}
            color="primary"
            onClick={() => setModal(true)}
          >
            Add Groups
          </Button>
        </Flex>
      </Flex>
      <Box
        border={1}
        style={{ overflowY: "auto" }}
        maxHeight={500}
        borderRadius={6}
        mb={3}
      >
        <SortableTable<GroupDto>
          columns={cols}
          data={value}
          emptyMessage="No groups have been added."
        />
      </Box>
    </>
  );
}
